<template>
	<div>
		<p class="duplicate-loan-text">
			Sorry, We couldn't create this loan because a loan with the same details
			already exists for this contact. Please go to that loan to edit the
			details.
		</p>
		<footer class="footer">
			<button class="b360-btn b360-modal-action-btn" @click="handleOK">
				OK
			</button>
		</footer>
	</div>
</template>

<script>
export default {
	name: 'DuplicateLoan',
	methods: {
		handleOK() {
			this.$emit('ok');
		},
	},
};
</script>

<style lang="scss" scoped>
.duplicate-loan-text {
	display: flex;
	justify-content: center;
	@include rem('padding', 10px 20px);
}

.footer {
	display: flex;
	justify-content: center;
	@include rem('padding', 15px 20px);
	border-top: 1px solid $border-color-light;
}
</style>
